import React from "react";
import styles from "../../asset/Service/Artwork.module.scss";
import WhoWeAreImage from "../../asset/homefour/namedrop/namedrop1.webp"
import WhoWeAreImage1 from "../../asset/homefour/namedrop/namedrop2.webp"
import WhoWeAreImage2 from "../../asset/homefour/namedrop/namedrop3.webp"
import WhoWeAreImage3 from "../../asset/homefour/namedrop/namedrop4.webp"
import { Link } from "react-router-dom";


const Namedrop = () => {
  const artworks = [
    {
      img: WhoWeAreImage,
      title: "Replication",
      link: "/portfolio/3",
    },
    {
      img: WhoWeAreImage1,
      title: "Mascots & Icons",
      link: "/portfolio/11",
    },
    {
      img: WhoWeAreImage2,
      title: "Custom Design",
      link: "/portfolio/12",
    },
    {
      img: WhoWeAreImage3,
      title: "Embroidery",
      link: "/portfolio/13",
    },
  ];

  return (
    <section className={styles.artworkSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Namedrop</h2>
        <p className={styles.description}>
         Namedrop is the process of creating vector artwork or digitized files from a selected design by replacing the logo, colors, icons, and text—while preserving the exact layout. We provide Namedrop services to custom-decorating apparel companies serving the Collegiate, Resort, Professional Sports, Retail, Golf, and Military markets.
        </p>
         <p className={styles.description}>Namedrops are used across various imprinting methods or machine embroidery on a wide range of products including apparel, promotional items, headwear, sportswear, and accessories. Simply provide us with the reference design, and we will replace the logo and verbiage according to your specifications, while maintaining the integrity of the original design layout.
</p>
          <p className={styles.description}>Typically, logos, colors, icons, text, and sizes are adapted to match the reference design, all while strictly adhering to trademark licensing requirements.</p>

        <div className={styles.grid}>
          {artworks.map((item, index) => (
            <div key={index} className={styles.card}>
              <img src={item.img} alt={item.title} className={styles.image} />
              <div className={styles.cardContent}>
                <h3>{item.title}</h3>
                   <Link to={item.link} className={styles.arrowBtn}>
                   →
                 </Link>
              </div>
            </div>
          ))}
        </div>

        {/* <div className={styles.faqSection}>
          <p>
            Want to know more? Look up our FAQ page or speak to our responsive
            customer support team.
          </p>
          <button className={styles.faqBtn}>Let's get started</button>
        </div> */}
      </div>
    </section>
  );
};

export default Namedrop;
